import { render, staticRenderFns } from "./resourceUse.vue?vue&type=template&id=a925b370&scoped=true"
import script from "./resourceUse.vue?vue&type=script&lang=js"
export * from "./resourceUse.vue?vue&type=script&lang=js"
import style0 from "./resourceUse.vue?vue&type=style&index=0&id=a925b370&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a925b370",
  null
  
)

export default component.exports